import { useOutlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navigation } from './components/Navigation';
import { Layout } from './layout';
import s from  './index.module.scss';

const LoanTermsPage = () => {
  const { t } = useTranslation('loan-terms');
  const outlet = useOutlet();

  if (outlet) return <Layout>{outlet}</Layout>;

  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.header}>
          <h1 className="f-hero-h2">{t('root_page.title')}</h1>
          <p className="f-paragraph-regular">{t('root_page.description')}</p>
        </div>
        <Navigation className={s.navigation} />
      </div>
    </div>
  );
};

export default LoanTermsPage;
